import moment from 'moment';

const INVALID_CHARS = /[/\\?%*:|"<>]/g;

/** 清理文件名片段中的非法字符 */
export function sanitizeFilePart(value, fallback = '') {
  if (value == null || value === '') return fallback;
  return String(value)
    .trim()
    .replace(INVALID_CHARS, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '') || fallback;
}

/**
 * 根据页面筛选项片段生成报告文件名（含时间戳）
 * @param {Array<string|number|null|undefined>} parts 页面传入的筛选项标签
 * @param {{ timeFormat?: string }} options
 */
export function buildZzlReportFileStem(parts, { timeFormat = 'YYYYMMDD_HHmmss' } = {}) {
  const segments = (Array.isArray(parts) ? parts : [parts])
    .map((p) => sanitizeFilePart(p, ''))
    .filter(Boolean);
  const base = segments.length ? segments.join('_') : 'AI报告';
  return `${base}_${moment().format(timeFormat)}`;
}

/** PDF 导出：日期精度到日 */
export function buildZzlPdfFileStem(parts) {
  return buildZzlReportFileStem(parts, { timeFormat: 'YYYYMMDD' });
}

/**
 * 知识库保存：基于 PDF 干名补全到秒，避免同日多次保存冲突；
 * 也可直接传入筛选项数组生成完整文件名。
 */
export function buildZzlSaveFileStem(stemOrParts) {
  if (Array.isArray(stemOrParts)) {
    return buildZzlReportFileStem(stemOrParts);
  }
  const stem = sanitizeFilePart(stemOrParts, 'AI报告');
  if (/_\d{8}_\d{6}$/.test(stem)) return stem;
  if (/_\d{8}$/.test(stem)) {
    return `${stem}_${moment().format('HHmmss')}`;
  }
  return buildZzlReportFileStem([stem]);
}
